import * as requestFromServer from "./StudentReportCrud";
import { callTypes, studentReportSlice } from "./StudentReportSlice";

const {actions} = studentReportSlice;

export const getRegistrationCancellationReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getRegistrationCancellationReport(queryParams)
    .then(response => {
      dispatch(actions.studentReportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllRegistrationCancellationReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getAllRegistrationCancellationReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getStudentReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getStudentReport(queryParams)
    .then(response => {
      dispatch(actions.studentReportFetched(response.data));
    })
    .catch(error => {
      
    });
};

// export const getAllPersonnelReport = queryParams => async dispatch => {
//   dispatch(actions.startCall({ callType: callTypes.action }));
//   return requestFromServer
//     .getAllPersonnelReport(queryParams)
//     .then(response => {
//       dispatch(actions.actionCompleted());
//       return response.data;
//     })
//     .catch(error => {
      
//     });
// };

export const getPersonnelTypes = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getPersonnelTypes()
    .then(response => {
      dispatch(actions.personnelTypesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const activateRegistrations = (term, studentId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .activateRegistrations(term, studentId)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteStudents = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteStudents(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanStudentReportState = () => dispatch => {
  dispatch(actions.studentReportStateCleaned());
}